(function () {
    const meta = document.querySelector('meta[data-link-prefetch]');
    if (!meta || meta.dataset.bound === '1') return;
    meta.dataset.bound = '1';

    const delay = parseInt(meta.dataset.delay || '100', 10);
    const max = parseInt(meta.dataset.max || '16', 10);
    const selector = meta.dataset.selector || 'a';

    const conn = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
    if (conn) {
      if (conn.saveData === true) return;
      const eff = conn.effectiveType || '';
      if (eff === 'slow-2g' || eff === '2g') return;
    }

    const prefetched = new Set();
    let count = 0;
    let timer = null;
    let activeLink = null;

    const isPrefetchable = (a) => {
      if (!a || !a.href) return false;
      if (a.target && a.target !== '' && a.target !== '_self') return false;
      try {
        const url = new URL(a.href, window.location.origin);
        if (url.origin !== window.location.origin) return false;
        if (url.pathname === window.location.pathname) return false;
        if (prefetched.has(url.href)) return false;
        return true;
      } catch (e) {
        return false;
      }
    };

    const prefetch = (href) => {
      if (count >= max) return;
      if (prefetched.has(href)) return;
      prefetched.add(href);
      count += 1;
      const link = document.createElement('link');
      link.rel = 'prefetch';
      link.href = href;
      link.as = 'document';
      document.head.appendChild(link);
    };

    const onEnter = (e) => {
      const a = e.target.closest(selector);
      if (!a || !isPrefetchable(a)) return;
      activeLink = a;
      clearTimeout(timer);
      timer = setTimeout(() => {
        if (activeLink !== a) return;
        prefetch(a.href);
      }, delay);
    };

    const onLeave = (e) => {
      const a = e.target.closest(selector);
      if (!a) return;
      if (activeLink === a) activeLink = null;
      clearTimeout(timer);
    };

    const onTouch = (e) => {
      const a = e.target.closest(selector);
      if (a && isPrefetchable(a)) prefetch(a.href);
    };

    document.addEventListener('pointerover', onEnter, { passive: true });
    document.addEventListener('pointerout', onLeave, { passive: true });
    document.addEventListener('touchstart', onTouch, { passive: true });
  })();
